/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { SharedDataCache } from '../../core/common/shared.data';
import { I18NGroup } from '../../core/common/base.data';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcI18NComponent),
    multi: true
};

/**
 * Label
 */
@Component({
    selector: 'ngc-i18n',
    template: `{{_i18nvalue}}`,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcI18NComponent extends ControlComponent {
    private _group: string = I18NGroup.FUNCTION;
    private _i18nvalue: string = "";
    //

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * Group
     */
    @Input("group")
    set group(group: string) {
        if (this._group !== group) {
            this._group = group;
            this.modelUpdated(this._group);
            // Refresh
            this.valueUpdateCallback();
        }
    }

    /**
     * Call on Value Update (Overridden)
     */
    public valueUpdateCallback(): void {
        // Update i18n Value
        if (this.value && this._group) {
            this._i18nvalue = SharedDataCache.getI18NData(this.value, this._group);
            // If Not Found
            if (!this._i18nvalue) {
                this._i18nvalue = "~i18n~" + this.value;
            }
        }
    }

}

/**
 * Label Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcI18NComponent],
    declarations: [NgcI18NComponent]
})
export class NgcI18NModule {
}